import React, { FunctionComponent, useMemo } from 'react';
import { useStore } from 'effector-react';
import mentionsOfficialAccountPost, {
  getList,
  PAGE_SIZE_STORAGE_KEY,
} from '@stores/mentionsOfficialAccountPost';
import MentionsOfficialAccountPostMentionCard from '@components/MentionsOfficialAccountPostCard';
import { Spin, Empty, Button, Select } from 'antd';
import { getMentionsPageSize, mentionsPageSizeOptions } from '@constants/pagination';
import componentContent from './MentionsOfficialAccountPostList.content.json';
import useTranslate from '@hooks/useTranslate';
import css from './MentionsOfficialAccountPostList.module.less';

interface MentionsOfficialAccountPostListProps {}

const MentionsOfficialAccountPostList: FunctionComponent<
  MentionsOfficialAccountPostListProps
> = () => {
  const { list, hasMore, nextLastDate, preloaders, pagination, setPagination } = useStore(
    mentionsOfficialAccountPost,
  );
  const content = useTranslate(componentContent);

  const isListLoading = useMemo(() => !!preloaders.getList, [preloaders]);
  const currentPageSize = getMentionsPageSize(
    localStorage.getItem(PAGE_SIZE_STORAGE_KEY) || pagination.pageSize,
  );

  const pageSizeChange = (pageSize: number) => {
    localStorage.setItem(PAGE_SIZE_STORAGE_KEY, `${pageSize}`);
    setPagination({ ...pagination, pageSize });
    getList({ pagination: { pageSize, lastDate: null } });
  };

  const loadMore = () => {
    getList({ pagination: { pageSize: currentPageSize, lastDate: nextLastDate } });
  };

  if (!list.length && !isListLoading && !hasMore) {
    return <Empty />;
  }

  return (
    <div>
      <div className={css.controls}>
        <Select
          value={currentPageSize}
          onChange={pageSizeChange}
          disabled={isListLoading}
        >
          {mentionsPageSizeOptions.map((pageSize) => (
            <Select.Option
              value={Number(pageSize)}
              key={pageSize}
            >
              {pageSize}
            </Select.Option>
          ))}
        </Select>
      </div>

      <Spin spinning={isListLoading}>
        <div className={css.root}>
          {list.length ? (
            list.map((post) => (
              <MentionsOfficialAccountPostMentionCard
                post={post}
                key={post.id}
              />
            ))
          ) : (
            <Empty />
          )}
        </div>
      </Spin>

      {hasMore && (
        <div className={css.controls}>
          <Button
            onClick={loadMore}
            loading={isListLoading}
          >
            {content.show_more}
          </Button>
        </div>
      )}
    </div>
  );
};

export default MentionsOfficialAccountPostList;
